import queryString from "query-string";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { createRecruiter } from "../../../actions/recruiters/individualActions";

import { getCurrentIndividual } from "../../../selectors/individualSelectors";

import CommunityRegistrationForm from "./FormTypes/CommunityRegistrationForm";
import LegacyRegistrationForm from "./FormTypes/LegacyRegistrationForm";
import SolicitorRegistrationForm from "./FormTypes/SolicitorRegistrationForm";
import TALKAgencyRegistrationForm from "./FormTypes/TALKAgencyRegistrationForm";
import LoggedInContent from "./LoggedInContent";

function RecruiterRegistrationForm({
  loggedIn,
  match,
  location,
  createRecruiter,
}) {
  const legacyInvitationToken = match.params.legacy_invitation_id;
  const solicitedEmployerId = queryString.parse(
    location.search
  ).solicited_employer;

  const solicitedEmployerProfileId = queryString.parse(
    location.search
  ).solicited_employer_profile;

  const renderForm = () => {
    if (legacyInvitationToken) {
      return (
        <LegacyRegistrationForm
          legacyInvitationToken={legacyInvitationToken}
          createRecruiter={createRecruiter}
        />
      );
    } if (solicitedEmployerId) {
      return (
        <SolicitorRegistrationForm
          solicitedEmployerId={solicitedEmployerId}
          solicitedEmployerProfileId={solicitedEmployerProfileId}
          createRecruiter={createRecruiter}
        />
      );
    } if (location.pathname === "/public/talk-agency-registration") {
      return <TALKAgencyRegistrationForm createRecruiter={createRecruiter} />;
    }
    return <CommunityRegistrationForm createRecruiter={createRecruiter} />;
  };

  const renderLoggedInContent = () => (
    <LoggedInContent
      title={
        legacyInvitationToken ? "Agency Registration" : "Agency Application"
      }
    />
  );

  return (
    <div style={{ width: 768 }}>
      {loggedIn ? renderLoggedInContent() : renderForm()}
    </div>
  );
}

const mapStateToProps = (state) => ({
  loggedIn: Boolean(getCurrentIndividual(state)),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  createRecruiter: (data) => dispatch(createRecruiter(data)).then(() => ownProps.history.push("/activation")),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RecruiterRegistrationForm)
);
